"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function IONuclearOutline(props) {
    let { width, height, size } = props;
    if (size !== undefined) {
        width = size;
        height = size;
    }
    if (width === undefined && height === undefined) {
        width = 16;
        height = 16;
    }
    return (react_1.default.createElement("svg", { className: "glx--icon glx-io-icon", width: width, height: height, xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 512 512" },
        react_1.default.createElement("circle", { cx: "256", cy: "256", r: "192", fill: "none", stroke: "#000", strokeLinecap: "round", strokeMiterlimit: "10", strokeWidth: "32" }),
        react_1.default.createElement("circle", { cx: "256", cy: "256", r: "64", fill: "none", stroke: "#000", strokeMiterlimit: "10", strokeWidth: "32" }),
        react_1.default.createElement("path", { fill: "none", stroke: "#000", strokeLinecap: "round", strokeMiterlimit: "10", strokeWidth: "32", d: "M224 192L171 85" }),
        react_1.default.createElement("path", { fill: "none", stroke: "#000", strokeLinecap: "round", strokeMiterlimit: "10", strokeWidth: "32", d: "M288 192L341 85" }),
        react_1.default.createElement("path", { fill: "none", stroke: "#000", strokeLinecap: "round", strokeMiterlimit: "10", strokeWidth: "32", d: "M327.55 255.81L446.96 255.94" }),
        react_1.default.createElement("path", { fill: "none", stroke: "#000", strokeLinecap: "round", strokeMiterlimit: "10", strokeWidth: "32", d: "M299.09 313.13L371.34 408.19" }),
        react_1.default.createElement("path", { fill: "none", stroke: "#000", strokeLinecap: "round", strokeMiterlimit: "10", strokeWidth: "32", d: "M184.45 255.81L65.04 255.94" }),
        react_1.default.createElement("path", { fill: "none", stroke: "#000", strokeLinecap: "round", strokeMiterlimit: "10", strokeWidth: "32", d: "M212.91 313.13L140.66 408.19" })));
}
exports.default = IONuclearOutline;
